import { Button, Col, DatePicker, Form, Input, Row, Space } from 'antd';
import { useEffect } from 'react';
import styled from 'styled-components';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons';

const StyledDiv = styled.div`
  .ant-picker-input.ant-input {
    width: 100%;
  }
  .ant-col.ant-form-item-label {
    padding: 0;
  }
  .ant-row.ant-row-center {
    height: 60px;
  }
`;

interface SearchTaxInvoiceComponentProps {
  searchData: any;
  searchTaxInvoices: (data: any) => void;
  initSearchForm: () => void;
}
function SearchTaxInvoiceComponent({
  searchData,
  searchTaxInvoices,
  initSearchForm,
}: SearchTaxInvoiceComponentProps) {
  const [form] = Form.useForm();
  const dateFormat = 'YYYY-MM-DD';

  useEffect(() => {
    if (searchData) {
      form.setFieldsValue({ ...searchData });
    }
  }, [searchData, form]);

  return (
    <StyledDiv>
      <Form
        form={form}
        layout="vertical"
        onFinish={searchTaxInvoices}
        initialValues={searchData}
        style={{
          border: '2px solid #bcbcbc',
          marginRight: '10px',
          height: '300px',
        }}
      >
        <Row justify="center" style={{ marginTop: '10px', height: '40px' }}>
          <Col>
            <Form.Item>
              <Space size="middle">
                <Button
                  htmlType="button"
                  onClick={initSearchForm}
                  size="small"
                  icon={<ClearOutlined rev={undefined} />}
                >
                  초기화
                </Button>
                <Button
                  htmlType="submit"
                  type="primary"
                  size="small"
                  icon={<SearchOutlined rev={undefined} />}
                >
                  검색
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item
              name="startDate"
              label="시작일(작성일 기준)"
              rules={[
                {
                  required: true,
                  message: '시작일을 선택해 주세요.',
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: '180px' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item
              name="endDate"
              label="종료일(작성일 기준)"
              rules={[
                {
                  required: true,
                  message: '종료일을 선택해 주세요.',
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: '180px' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item name="companyName" label="상호명">
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col>
            <Form.Item name="corporateNumber" label="사업자등록번호">
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </StyledDiv>
  );
}

export default SearchTaxInvoiceComponent;
